import { fetchUsps } from "../../utils/api";

export const fetchAndHandleUsps = () => dispatch => {
  return fetchUsps('?type=product_page_general,product_page_payments,product_page_delivery')
    .then(res => {
      dispatch({ type: "FETCH_USP_SUCCESS", payload: res.data });
    })
    .catch(err => {
      dispatch({ type: "FETCH_USP_ERROR", err });
    });
};
